import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map, TileLayer, ZoomControl } from 'react-leaflet';
import $ from 'jquery';

import { arraysEqual } from '~/core/scripts/utils';
import Icon from '~/core/scripts/components/Icon';
import { disableMap, enableMap } from '~/core/scripts/map-components/utils';
import LabelsLayer from '~/core/scripts/map-components/LabelsLayer';
import { is768Query } from '~/core/scripts/mediaquery-helper';

import 'leaflet/dist/leaflet.css';
import './BasisMap.styl';

class MapComponent extends PureComponent {
  static propTypes = {
    center: PropTypes.array,
    zoom: PropTypes.number,
    minZoom: PropTypes.number,
    maxZoom: PropTypes.number,
    zoomSnap: PropTypes.number,
    zoomDelta: PropTypes.number,
    maxBounds: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
    fitBounds: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),

    zoomControl: PropTypes.string,

    showGeocoder: PropTypes.bool,
    zoomAfterGeocode: PropTypes.number,

    showBasemap: PropTypes.bool,
    basemapUrl: PropTypes.string,
    basemapAttribution: PropTypes.string,

    showLabels: PropTypes.bool,
    zoomAnimation: PropTypes.bool,
    showMapToggleButton: PropTypes.bool,
    isFullScreen: PropTypes.bool
  }

  static defaultProps = {
    center: null,
    zoom: null,
    minZoom: baseconfig.app.minZoom || 7,
    maxZoom: 15,
    zoomDelta: 0.5,
    zoomSnap: 0.5,
    maxBounds: null,
    fitBounds: null,

    zoomControl: 'bottomright',

    showBasemap: true,
    // basemapUrl: 'https://maps.tilehosting.com/c/a0a037d7-f288-42a8-88cf-666cf06cee7a/styles/basemap-berlin-4f0b1/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz',
    // basemapUrl: 'https://api.maptiler.com/maps/87484079-15a2-4cf6-af60-f8a18dd7c57e/256/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz',
    basemapUrl: 'https://tiles.interaktiv.cloud.funkedigital.de/light-labels/{z}/{x}/{y}@2x.png',
    basemapAttribution: 'Karte: <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',

    showGeocoder: false,
    zoomAfterGeocode: 11,

    showLabels: true,
    showMapToggleButton: false,
    isFullScreen: true,
    zoomAnimation: true
  }

  state = {
    isMapActive: false,
  }

  constructor() {
    super();

    // we only want to set fitBounds once
    this.initFitBounds = false;
    this.initMove = true;
    this.lastRoundedZoom = 0;
  }

  componentDidMount() {
    if (!this.state.isMapActive && !this.props.isFullScreen) {
      disableMap(this.map.leafletElement);
    }
  }

  componentDidUpdate(prevProps) {
    if (!arraysEqual(this.props.geocoderLatLng, prevProps.geocoderLatLng)) {
      this.map.leafletElement.setView(this.props.geocoderLatLng, this.props.zoomAfterGeocode);
    }

    if (!this.initFitBounds && this.props.fitBounds) {
      this.map.leafletElement.fitBounds(this.props.fitBounds);
      this.initFitBounds = true;
    }
  }

  renderZoomControl() {
    if (!this.props.zoomControl || !is768Query()) {
      return null;
    }

    return <ZoomControl position={this.props.zoomControl} />;
  }

  renderBasemap() {
    return (
      <TileLayer
        url={this.props.basemapUrl}
        attribution={this.props.basemapAttribution}
        minZoom={12.1}
        maxZoom={20}
      />
    );
  }

  renderMapToggleButton() {
    if (!this.props.showMapToggleButton) {
      return null;
    }

    return (
      <button className="maptoggle" onClick={this.toggleMapActive}>
        {this.state.isMapActive ?
          <div><Icon type="scroll" /> Scrollen aktivieren</div> :
          <div><Icon type="move" /> Karte aktivieren</div>
        }
      </button>
    )
  }

  renderLabels() {
    if (!this.props.showLabels) {
      return null;
    }

    return (
      <LabelsLayer
        preset={this.props.labelPreset}
        labels={this.props.customLabels}
      />
    );
  }

  toggleMapActive = () => {
    if (!this.map) {
      return false;
    }
    if (this.state.isMapActive) {
      disableMap(this.map.leafletElement);
    } else {
      enableMap(this.map.leafletElement);
    }

    const isMapActive = !this.state.isMapActive;
    this.setState({ isMapActive });
    $('html').toggleClass('is-map-active', isMapActive);
  }

  onZoom = (evt) => {
    this.onMove();

    $('html').removeClass(`map-zoom-${this.lastRoundedZoom}`);
    this.lastRoundedZoom = Math.round(evt.target._zoom);
    $('html').addClass(`map-zoom-${this.lastRoundedZoom}`);
  }

  onDrag = () => {
    this.onMove();
  }

  onDragStart = () => {
    this.props.setDetailPos(false);
  }

  onMove() {
    if (this.initMove) {
      this.initMove = false;
      return false;
    }

    document.querySelector('html').classList.add('map-moved');
  }

  render() {
    return (
      <Map
        className="map"
        ref={ref => { this.map = ref; }}
        center={this.props.center}
        zoom={this.props.zoom}
        zoomControl={false}
        zoomDelta={this.props.zoomDelta}
        zoomSnap={this.props.zoomSnap}
        minZoom={this.props.minZoom}
        maxZoom={this.props.maxZoom}
        maxBounds={this.props.maxBounds}
        zoomAnimation={this.props.zoomAnimation}
        onZoomStart={this.onDragStart}
        onZoomEnd={this.onZoom}
        onDragEnd={this.onDrag}
        onDragStart={this.onDragStart}
      >
        {this.renderZoomControl()}
        {this.renderBasemap()}
        {this.props.children}
        {this.renderLabels()}
        {this.renderMapToggleButton()}
      </Map>
    );
  }
}

export default MapComponent;
